/**
 * Ranges and helpers for the sketch presets a client configures under
 * Einstellungen → IRES Project → Skizze.
 *
 * Only the wall thickness presets live here; the older room height preset keeps its inline range
 * in `ProjectManagerSettings.vue`. See `docs/settings/sketch-presets.md`.
 */

/**
 * A wall thickness preset is 0 (= no preset, "0 = keine") up to 99 cm.
 * The ceiling is exclusive of 100 by request: "0, or a value > 0 and less than 100".
 */
export const WALL_THICKNESS_PRESET_MIN = 0;
export const WALL_THICKNESS_PRESET_MAX = 99;

/**
 * Keeps a wall thickness typed into the settings field inside its range.
 * A value that is not a number (an empty or malformed field) is handed back untouched, so the
 * save can reject it instead of the field silently rewriting itself.
 */
export function clampWallThicknessPreset(value: number): number {
  if (value < WALL_THICKNESS_PRESET_MIN) {
    return WALL_THICKNESS_PRESET_MIN;
  }

  if (value > WALL_THICKNESS_PRESET_MAX) {
    return WALL_THICKNESS_PRESET_MAX;
  }

  return value;
}

/** True for a wall thickness that may be saved. `NaN` is never valid. */
export function isValidWallThicknessPreset(value: number): boolean {
  return value >= WALL_THICKNESS_PRESET_MIN && value <= WALL_THICKNESS_PRESET_MAX;
}
